module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-ingresso-personalizado-768x591.fe1c31e8.jpg";